import React from 'react';

export default function IncidentReport() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Incident Report</h1>
      <p className="text-gray-500">Halaman Incident Report</p>
    </div>
  );
}
